/**
 * Live token pacing for Connie / Salma.
 * Viewport pins to the message start, so we can commit more text per tick
 * than the original 3-char / 22ms cadence.
 */
export const STREAM_DELTA_DELAY_MS = 14;
export const STREAM_BASE_CHARS_PER_TICK = 10;
export const STREAM_MAX_TICKS_PER_DELTA = 72;
export const STREAM_LARGE_DELTA_CHARS = 4_000;
export const STREAM_LARGE_MAX_TICKS_PER_DELTA = 18;

export const waitForStreamPaint = () =>
  new Promise<void>(resolve => {
    window.setTimeout(() => {
      requestAnimationFrame(() => resolve());
    }, STREAM_DELTA_DELAY_MS);
  });

export const getStreamCharsPerTick = (textLength: number) => {
  const maxTicks =
    textLength >= STREAM_LARGE_DELTA_CHARS
      ? STREAM_LARGE_MAX_TICKS_PER_DELTA
      : STREAM_MAX_TICKS_PER_DELTA;

  return Math.max(
    STREAM_BASE_CHARS_PER_TICK,
    Math.ceil(textLength / maxTicks)
  );
};
